import {
  SUBMIT_ESTIMATE,
  ESTIMATE_BOOKING,
  ESTIMATE_BOOKING_SUCCESS,
  ESTIMATE_BOOKING_FAILURE,
  DISPLAY_FORM_VALIDATION_ERRORS,
} from '../actions/estimate';
import type { State } from './index';
import { Api } from '../../common/model';

export interface EstimateState {
  isFetching: boolean;
  estimation?: Api.FastBookingEstimation;
  hasBeenSubmit: boolean;
  displayFormValidationErrors: boolean;
  error?: string;
}

const initialState: EstimateState = {
  isFetching: false,
  hasBeenSubmit: false,
  displayFormValidationErrors: false,
};

export default (state: EstimateState = initialState, action: any) => {
  switch (action.type) {
    case SUBMIT_ESTIMATE:
      return {
        ...state,
        hasBeenSubmit: true,
      };
    case DISPLAY_FORM_VALIDATION_ERRORS:
      return {
        ...state,
        displayFormValidationErrors: action.value,
        estimation: action.value ? undefined : state.estimation,
      };
    case ESTIMATE_BOOKING:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case ESTIMATE_BOOKING_SUCCESS:
      return {
        ...state,
        estimation: action.estimation,
        isFetching: false,
        error: undefined,
      };
    case ESTIMATE_BOOKING_FAILURE:
      return {
        ...state,
        estimation: undefined,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const hasBeenFetched = (state: State) => !!state.estimate.estimation;
export const getIsFetching = (state: State) => state.estimate.isFetching;
export const getDisplayFormValidationErrors = (state: State) => state.estimate.displayFormValidationErrors;
export const getEstimation = (state: State) => state.estimate.estimation;
export const getEstimationError = (state: State) => state.estimate.error;
